export const NOTIFICATION_DISMISS_TIME = 5000;
